import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { StaffAuthzService } from './staff-authz.service';

/** 초대를 수락하지 않은 staff 가 안내받는 화면 경로 — 앱이 이 경로에 `StaffInvitationInboxComponent` 를 둔다. */
export const STAFF_INVITATION_INBOX_PATH = '/my-invitations';

/**
 * 초대를 수락하지 않은 staff(`Pending`·`Rejected`·`Cancelled`·`Expired`)를 초대 수락 화면으로 보낸다. **UI 보호일 뿐**이다 — 서버는 수락 전 staff 의 scope 요구를 독립적으로 거부한다.
 * `staffAuthGuard` 를 가진 그룹의 자식에 둔다(부모 `canActivate` 가 `me` 를 채운 뒤여야 한다). 초대 수락 화면 자신에는 두지 않는다(루프).
 * 상태를 알 수 없으면(초대 미도입 앱·`me` 없음) 통과시킨다.
 */
export const staffAcceptedGuard: CanActivateFn = () => {
  if (inject(StaffAuthzService).accepted()) return true;
  return inject(Router).createUrlTree([STAFF_INVITATION_INBOX_PATH]);
};
